import { render } from "./ClientesEmail.vue?vue&type=template&id=79d46341&scoped=true"
import script from "./ClientesEmail.vue?vue&type=script&lang=ts"
export * from "./ClientesEmail.vue?vue&type=script&lang=ts"

import "./ClientesEmail.vue?vue&type=style&index=0&id=79d46341&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79d46341"

export default script